import React, { Component } from 'react';

export default class BaseList extends Component {
    getSortParams(props) {
        props = props || this.props;
        let sortableList = props.sortableList[this.listId];

        if(!sortableList) {
            return {
                column: 'id',
                asc: false,
                search: '',
                portalId: '',
                withDeleted: 1,
            };
        }

        let params ={
            orderBy: sortableList.column,
            direction: sortableList.asc ? 'ASC' : 'DESC',
            s: sortableList.search,
        };

        if(sortableList.withDeleted) {
            params.withDeleted = 1
        }

        if(!sortableList.column) {
            params.column = 'id';
        }

        if(sortableList.portalId) {
            params.portalId = sortableList.portalId;
        }

        return params;
    }

    sortParamWasChanged(nextProps) {
        let preSortableList = this.props.sortableList[this.listId];
        let sortableList = nextProps.sortableList[this.listId];

        if(!sortableList) {
            return false;
        }

        if(!preSortableList) {
            return true;
        }

        return !(
            preSortableList.column === sortableList.column &&
            preSortableList.asc === sortableList.asc &&
            preSortableList.withDeleted === sortableList.withDeleted
        );
    }
};


// WEBPACK FOOTER //
// ./web/src/components/common/list/BaseList.jsx